import { EllipsisText } from '../ellipsis-text';
import { Text } from '../text';

interface ReadonlyFieldContentProps {
  content: string | JSX.Element;
  maxLines?: number;
}

export default function ReadonlyFieldContent(props: Readonly<ReadonlyFieldContentProps>) {
  const { content, maxLines } = props;

  if (typeof content !== 'string') {
    return content;
  }

  if (maxLines) {
    return (
      <EllipsisText maxLines={maxLines} sx={{ width: '100%' }}>
        {content}
      </EllipsisText>
    );
  }

  return <Text component='span'>{content}</Text>;
}
